import React from "react";

export type PathSelection = { start: string; goal: string } | null;

export interface PathSelectionContextValue {
  readonly selection: PathSelection;
  readonly setSelection: (s: PathSelection) => void;
}

export const PathSelectionContext =
  React.createContext<PathSelectionContextValue>({
    selection: null,
    setSelection: (_s: PathSelection): void => {
      /* default no-op replaced by provider */
    },
  });
